export default "https://static.wetvinfo.com/tv/linux/static/media/help_h.png";